window.addEventListener('load', () =>
{
    const videos = document.querySelectorAll('.js-video-autoplay');

    const observer = new IntersectionObserver((entries) =>
    {
        entries.forEach(entry =>
        {
            if (entry.isIntersecting)
            {
                const video = entry.target;
                video.setAttribute('autoplay', 'autoplay');
                video.load();
                observer.unobserve(video);
            }
        });
    }, {
        threshold: 0.5
    });

    videos.forEach(video => observer.observe(video));

    const muteButtons = document.querySelectorAll('.js-video-autoplay__volume-button');

    muteButtons.forEach((button, index) =>
    {
        const video = videos[index];
        button.addEventListener('click', () =>
        {
            video.muted = !video.muted;
            button.querySelector('i').className = video.muted
                ? 'fa-solid fa-volume-slash'
                : 'fa-solid fa-volume-high';
        });
    });
});
